import React from 'react';
import styles from '../../../styles/TaskDetails.module.css';
import EmptyState from '../../UI/EmptyState';

interface User {
  id: string;
  first_name: string;
  last_name: string;
  name: string;
  username: string;
  email: string;
  full_name?: string;
}

interface TaskAssignment {
  id: string;
  user: User;
  points_earned: number;
  status: 'pending' | 'in_progress' | 'completed';
  assigned_points: number;
  assigned_percentage: number;
  work_description: string;
  is_team_lead: boolean;
}

interface TaskAssigneesProps {
  assignees: TaskAssignment[];
  isInstance?: boolean;
  title?: string;
}

const TaskAssignees: React.FC<TaskAssigneesProps> = ({ assignees, isInstance = false, title }) => {
  // Check if assignees exist and have data
  const hasAssignees = assignees && Array.isArray(assignees) && assignees.length > 0;

  const displayTitle = title || (isInstance ? 'Who can access that instance' : 'Assignees');
  const emptyMessage = isInstance ? 'No users have access to this instance.' : 'No assignees for this task.';

  if (!hasAssignees) {
    return (
      <div className={styles.userAssignmentInfo}>
        <div className={styles.userAssignmentHeader}>
          <div className={styles.userAssignmentTitle}>{displayTitle}</div>
        </div>
        <EmptyState
          title={displayTitle}
          description={emptyMessage}
        />
      </div>
    );
  }

  return (
    <div className={styles.userAssignmentInfo}>
      <div className={styles.userAssignmentHeader}>
        <div className={styles.userAssignmentTitle}>{displayTitle}</div>
      </div>

      <div className={styles.assigneeList}>
        {assignees.map((assignment: TaskAssignment, index: number) => {
          // Handle case where assignment might be structured differently
          const user = assignment.user || assignment;
          const userId = user?.id || assignment.id || index;
          const firstName = user?.first_name || '';
          const lastName = user?.last_name || '';
          const email = user?.email || '';
          const fullName = user?.full_name || (firstName && lastName ? `${firstName} ${lastName}` : '');

          return (
            <div key={userId} className={styles.assigneeItem}>
              <div className={styles.assigneeAvatar}>
                {firstName?.[0]?.toUpperCase() || email?.[0]?.toUpperCase() || 'U'}
              </div>
              <div className={styles.assigneeInfo}>
                <div className={styles.assigneeName}>
                  {fullName || email || 'Unknown User'}
                  {assignment.is_team_lead && (
                    <span style={{
                      marginLeft: '8px',
                      fontSize: '12px',
                      color: '#f59e0b',
                      fontWeight: 600
                    }}>(Team Lead)</span>
                  )}
                </div>
                {email && (
                  <div className={styles.assigneeRole}>{email}</div>
                )}
                {assignment.work_description && (
                  <div style={{
                    marginTop: '8px',
                    padding: '8px',
                    backgroundColor: '#f3f4f6',
                    borderRadius: '6px',
                    fontSize: '14px',
                    color: '#374151',
                    lineHeight: '1.5'
                  }}>
                    <strong>Work Assigned:</strong> {assignment.work_description}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TaskAssignees;
